import _ from 'lodash';
/**
 * クリックしたリンクに足跡（丸）をつける
 * リンク跡を残したい要素（a）に data-footprint属性を付けておく
 */
class Footprint {

  /**
   * Create a new Router
   */
  constructor() {

    // データ（footprints）
    // ------------------
    // フォーマット： { pathname(string): [{left(string), top(string)}, ...] }
    this.footprints = {}

    // 色
    // --
    // 同じ色が連続しないよう、初期化時にランダムに並び替え、セッションの間、順番にまわしていく
    this.colors = _.shuffle(['#4E69FF', '#27FF6A', '#FFE839', '#FF4D4D'])
    this.currentColorIndex = 0

    $(document)
      .on('click', '.pageTop', () => {
        $('html,body').animate({
          scrollTop: 0
        }, 1000)
      })
      .on('click', 'a[data-footprint]', (e) => {
        const $el = $(e.target).closest('a[data-footprint]')
        const pathname = this.pathname($el.attr('href'))
        if (!this.footprints[pathname]) {
          this.footprints[pathname] = []
        }
        const offset = $el.offset();
        const x = e.pageX - offset.left;
        const y = e.pageY - offset.top;
        this.footprints[pathname].push({
          'left': parseInt(x / $el.width() * 100, 10) + '%',
          'top': parseInt(y / $el.height() * 100, 10) + '%',
          'background-color': this.color()
        })
      })
  }

  // Public functions
  // ============================

  // ページの読み込み時に呼び出され、footprintをレンダリング
  init() {
    $('a[data-footprint]').each((index, element) => {
      const pathname = this.pathname($(element).attr('href'))
      if (this.footprints[pathname]) {
        this.footprints[pathname].forEach(fp => {
          $(element).append($('<i class="footprint"></i>').css(fp))
        });
      }
    })
  }

  // Private functions
  // ============================

  // originは省いてそれ以降のpathnameを取得
  pathname(str) {
    return new URL(str, location.origin).pathname
  }

  // 順番に色を返す
  color() {
    const color = this.colors[this.currentColorIndex]
    this.currentColorIndex++
    if (this.colors.length <= this.currentColorIndex) {
      this.currentColorIndex = 0
    }
    return color
  }
}

export default Footprint;
